import React, { useEffect, useState } from "react";
import { IMachine as Machine } from "../../interfaces";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { modalActions } from "../../store/Modal.store";
import useSortTasks from "../hooks/useSortMachines";
import ButtonsSort from "../TasksSection/ButtonsSort";
import MachineItem from "../TasksSection/TaskItem/MachineItem";
import {
  CurrentUser,
  FullDataWithPlan,
  getRegMachineLimit,
} from "../Service/EndPoints";
import { useMemberstack } from "@memberstack/react";

type Props = {
  title: string;
  machines: Machine[] | [];
};

const LayoutRoutes: React.FC<Props> = ({ title, machines }) => {
  const [isListInView1, setIsListInView1] = useState<boolean>(false);

  const dispatch = useAppDispatch();

  const { sortedBy, setSortedBy, sortedTasks } = useSortTasks(machines);
  const isTabletMid = useAppSelector((state) => state.menu.isTabletMid);
  const LIMIT = useAppSelector((state) => state.machines.LIMIT);
  const isDisabled = machines.length >= LIMIT ? true : false;
  const openModalHandler = () => {
    dispatch(modalActions.openModalCreateTask());
  };

  const tasksTitle = `${title} (${machines.length} ${
    machines.length === 1 ? "machine" : "machines"
  })`;

  var objPlans: any = localStorage.getItem("loggedinuserplans");
  if (objPlans != null) {
    objPlans = JSON.parse(objPlans);
  }
  var objActiveStrategies: any = localStorage.getItem("activestrategyies");
  if (objActiveStrategies != null) {
    objActiveStrategies = JSON.parse(objActiveStrategies);
  }

  return (
    <section>
      <div className=" py-4 shadow-inner flex-col w-auto   justify-center items-start gap-px ">
        <div className="self-stretch px-12 py-2  bg-zinc-800 justify-start items-center gap-4 lg:inline-flex  ">
          <div className="pr-3 py-2 rounded-lg justify-start items-start gap-1 flex">
            <div className="text-sky-100 text-lg  leading-relaxed">
              Product Access:
            </div>
          </div>

          {objPlans
            ? objPlans.map((data: any) => (
                <>
                  <div className=" text-sky-400 text-base  leading-normal hidden  lg:block  ">
                    |
                  </div>
                  <div className="text-sky-100 text-base  leading-normal mt-4 lg:mt-0 ">
                    {data.name}
                  </div>
                </>
              ))
            : null}
        </div>
      </div>
      <div className=" py-4 shadow-inner flex-col w-auto   justify-center items-start gap-px ">
        <div className="self-stretch px-12 py-2  bg-zinc-800 justify-start items-center gap-4 lg:inline-flex  ">
          <div className="pr-3 py-2 rounded-lg justify-start items-start gap-1 flex">
            <div className="text-sky-100 text-lg  leading-relaxed">
              Active Strategies:
            </div>
          </div>

          {objActiveStrategies
            ? objActiveStrategies.map((data: any) => (
                <>
                  <div className=" text-sky-400 text-base  leading-normal hidden  lg:block  ">
                    |
                  </div>
                  <div className="text-sky-100 text-base  leading-normal mt-4 lg:mt-0 ">
                    {data}
                  </div>
                </>
              ))
            : null}
        </div>
      </div>
      <h1 className="my-5 text-center sm:text-left sm:my-8 md:text-2xl text-lg dark:text-slate-200">
        {tasksTitle}
      </h1>

      <ButtonsSort
        isListInView1={isListInView1}
        setIsListInView1={setIsListInView1}
        sortedBy={sortedBy}
        setSortedBy={setSortedBy}
      />
      <ul
        className={`tasksList mt-4 grid  gap-2 sm:gap-4 xl:gap-6 ${
          isListInView1
            ? "grid-cols-1"
            : "2xl:grid-cols-4 xl:grid-cols-3 lg:grid-cols-2  grid-cols-1 items-end"
        }`}
      >
        {sortedTasks.map((machine) => (
          <MachineItem
            key={machine.id}
            isListInView1={isListInView1}
            machine={machine}
          />
        ))}
        <li>
          <button
            disabled={isDisabled}
            onClick={openModalHandler}
            className={`border-2 
            hover:shadow-slate-500
              w-full rounded-md
              
              border-dashed transition 
               text-[#E4EFF9]
               border-[#E4EFF9] hover:border-[#06B4FF] dark:hover:bg-slate-800 dark:hover:text-slate-300 ${
                 isListInView1 ? "h-20 sm:h-32" : "h-64 sm:h-[340px]"
               }`}
          >
            Add new machine
          </button>
        </li>
      </ul>
    </section>
  );
};

export default React.memo(LayoutRoutes);
